import React, { memo } from 'react';
import classNames from 'classnames';
import styles from './OneManyTitle.module.scss';
import { TEXT } from '../../constants';

type TitleTexts = {
  firstText: string;
  secondText: string;
  thirdText: string;
  thirdText1280?: string;
  thirdText960?: string;
  thirdText640?: string;
};

export const OneManyTitle = memo(function OneManyTitle({ isSub = false }: { isSub?: boolean }) {
  const title = (isSub ? TEXT.title.sub : TEXT.title.free) as TitleTexts;
  return (
    <div
      className={classNames(
        styles.oneManyTitle,
        isSub && styles.oneManyTitle_isSub,
        !isSub && styles.oneManyTitle_isEmail,
      )}
    >
      <div className={styles.firstText}>{title.firstText}</div>
      <div className={styles.secondText}>{title.secondText}</div>
      {isSub ? (
        <>
          <div className={classNames(styles.thirdText, styles.thirdText_default)}>
            {title.thirdText}
          </div>
          <div className={classNames(styles.thirdText, styles.thirdText_1280)}>
            {title.thirdText1280}
          </div>
          <div className={classNames(styles.thirdText, styles.thirdText_960)}>
            {title.thirdText960}
          </div>
          <div className={classNames(styles.thirdText, styles.thirdText_640)}>
            {title.thirdText640}
          </div>
        </>
      ) : (
        <>
          <div className={classNames(styles.thirdText, styles.thirdText_default)}>
            {title.thirdText}
          </div>
          <div className={classNames(styles.thirdText, styles.thirdText_960)}>
            {title.thirdText960}
          </div>
          <div className={classNames(styles.thirdText, styles.thirdText_640)}>
            {title.thirdText640}
          </div>
        </>
      )}
    </div>
  );
});
